'use client'

import cn from 'classnames'
import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

import { Modal } from '@booking/components/Modal'
import styles from '../index.module.scss'
import { useBookingExternal } from '../../../state/external.context'
import { formatMainLink } from '@/src/lib/link'

type RestrictionItem = {
  title?: string
  content: string
}

export default function RestrictionsModal({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const t = useTranslations('booking')
  const { externalData } = useBookingExternal()
  const { termsPath, faqPath } = externalData

  const items = useMemo<RestrictionItem[]>(() => {
    const raw = t.raw('ticket.selectQuantity.restrictions.items') as unknown
    return Array.isArray(raw) ? (raw as RestrictionItem[]) : []
  }, [t])

  const faqsHref = faqPath ? formatMainLink(faqPath) : ''
  const termsHref = termsPath ? formatMainLink(termsPath) : ''

  return (
    <Modal modalIsOpen={open} setModalIsOpen={onOpenChange} className={cn(styles.modal)}>
      <h3 className={styles.title}>{t('ticket.selectQuantity.restrictions.title')}</h3>

      {items.map((item, index) => (
        <div className={cn(styles.item)} key={index}>
          {item.title ? <strong>{item.title}</strong> : null}
          <div dangerouslySetInnerHTML={{ __html: item.content }} />
        </div>
      ))}

      <div className={cn(styles.terms)}>
        {t.rich('ticket.selectQuantity.restrictions.terms', {
          faqs: (chunks) =>
            faqsHref ? (
              <Link href={faqsHref} target="_blank">
                {chunks}
              </Link>
            ) : (
              <span>{chunks}</span>
            ),
          terms: (chunks) =>
            termsHref ? (
              <Link href={termsHref} target="_blank">
                {chunks}
              </Link>
            ) : (
              <span>{chunks}</span>
            ),
        })}
      </div>
    </Modal>
  )
}
